var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvancedSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.003,
    height: 28,
    viewBox: "0 0 28.003 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10813",
    "data-name": "Group 10813",
    transform: "translate(-24 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "configuration",
    d: "M.906,7.532h7.37a3.62,3.62,0,0,0,7.012,0H26.1a.906.906,0,0,0,0-1.813H15.289a3.62,3.62,0,0,0-7.012,0H.906a.906.906,0,1,0,0,1.813ZM11.783,4.813A1.813,1.813,0,1,1,9.97,6.625,1.815,1.815,0,0,1,11.783,4.813ZM26.1,14.8H22.352a3.62,3.62,0,0,0-7.012,0H.906a.906.906,0,1,0,0,1.813H15.34a3.62,3.62,0,0,0,7.012,0H26.1a.906.906,0,0,0,0-1.813Zm-7.251,2.719a1.813,1.813,0,1,1,1.813-1.813A1.815,1.815,0,0,1,18.846,17.518ZM26.1,23.879H22.471a.906.906,0,1,0,0,1.813H26.1a.906.906,0,0,0,0-1.813Zm-10.876,0H11.663a3.62,3.62,0,0,0-7.012,0H.906a.906.906,0,1,0,0,1.813H4.651a3.62,3.62,0,0,0,7.012,0h3.557a.906.906,0,1,0,0-1.813ZM8.157,26.6A1.813,1.813,0,1,1,9.97,24.785h0A1.815,1.815,0,0,1,8.157,26.6ZM18.2,24.146a.906.906,0,1,0,1.282,0A.939.939,0,0,0,18.2,24.146Z",
    transform: "translate(24.5 27.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17897",
    "data-name": "Rectangle 17897",
    width: 28,
    height: 28,
    transform: "translate(24 29)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSettings);
export default __webpack_public_path__ + "static/media/advanced-settings.f913a9afc32d2a6ccce6dac302421171.svg";
export { ForwardRef as ReactComponent };